module.exports = __webpack_public_path__ + "static/media/alucraft.561fdc03.png";